import { Controller } from '@hotwired/stimulus'

// Keep the active primary destination visible without moving the document vertically.
export default class OrderNavigationController extends Controller<HTMLElement> {
  static override targets = ['strip']
  declare readonly stripTarget: HTMLElement

  override connect(): void {
    const current = this.stripTarget.querySelector<HTMLElement>('[aria-current="page"]')
    if (current) this.stripTarget.scrollLeft = current.offsetLeft - (this.stripTarget.clientWidth - current.offsetWidth) / 2
  }

  close(event: Event): void {
    const escape = event instanceof KeyboardEvent && event.key === 'Escape'
    if (event instanceof KeyboardEvent && !escape) return
    this.element.querySelectorAll<HTMLDetailsElement>('details[open]').forEach((menu) => {
      if (escape || !menu.contains(event.target as Node)) {
        if (escape && menu.contains(document.activeElement)) menu.querySelector('summary')?.focus()
        menu.open = false
      }
    })
  }
}
